<template>
  <div
    class="pop-drop-wrapper"
    :class="{
      black: theme === 'black',
      white: theme === 'white',
      selected: $route.path.indexOf(`topic/list`) > -1,
    }"
  >
    <div class="pop-title">
      <span class="pop-title-text" :title="title">{{ title }}</span>
      <span class="pop-title-icon">
        <icon custom="ich-icon ich-icon-arraw-down" />
      </span>
    </div>
    <div class="pop-drop">



      <div class="drop-wrapper">
        <div
          class="drop-item"
          :class="{ selected: category.isVisible }"
          v-for="category in dropList"
          :key="category.id"
          @mouseover="subCategoryVisible(category)"
        >
          <div class="drop-item-header">
            <div class="header-name">
              <span class="name-text">{{ category.dmTypeName }}</span>
              <span class="name-icon">
                <Icon custom="ich-icon ich-icon-arraw-down"></Icon>
              </span>
            </div>
            <div class="header-list" v-if="category.dmLableList">
              <span
                v-for="label in category.dmLableList.slice(0, 8)"
                :key="label.id"
              >
                {{ label.lableName }}
              </span>
            </div>
          </div>
          <div class="drop-item-body" v-show="category.isVisible">
            <div
              class="body-list"
              v-for="label in category.dmLableList"
              :key="label.id"
            >
              <div class="body-list-name">
                {{ label.lableName }}
              </div>
              <div class="body-list-item">
                <router-link
                  :to="{ name: 'Special', params: { id: major.MajorID } }"
                  v-for="major in label.majorList"
                  :key="major.MajorID"
                  :title="major.MajorName"
                  >{{ major.MajorName }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { global } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      dropList: [],
    };
  },
  props: {
    theme: {
      type: String,
      default: "black",
    },
    title: {
      type: String,
      default: "全部分类",
    },
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      global.getDropNavList(this.siteConfig.agencyId).then((result) => {
        if (result.status === 1) {
          this.dropList = result.data;
          this.dropList.forEach((item, index) => {
            this.$set(item, "isVisible", false);
            if (index === 0) {
              item.isVisible = true;
            }
          });
        }
        //console.log(result);
      });
    },
    subCategoryVisible(item) {
      this.dropList.forEach((item, index) => {
        item.isVisible = false;
      });
      item.isVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
.pop-drop-wrapper {
  position: relative;
  cursor: pointer;
  z-index: 1000;
  text-align: center;
  width: 90px;
  .pop-title {
    height: 70px;
    line-height: 70px;
    font-size: 16px;
  }
  &.black {
    .pop-title {
      color: #aaa;
      .pop-title-icon {
        vertical-align: bottom;
        margin-left: 6px;
      }
    }
    &:hover {
      .pop-title {
        font-weight: bold;
        color: #227efa !important;
        .pop-title-icon {
          vertical-align: bottom;
          margin-left: 6px;
        }
      }
      &:before {
        position: absolute;
        content: " ";
        border-bottom: 2px solid #227efa !important;
        bottom: 15px;
        left: 0;
        width: 100%;
      }
      &:after {
        position: absolute;
        content: " ";
        border: 8px solid transparent;
        border-bottom: 8px solid #fff;
        bottom: 0;
        left: 50%;
        margin-left: -16px;
      }
    }
    &.selected {
      .pop-title {
        font-weight: bold;
        color: #fff;
        .pop-title-icon {
          vertical-align: bottom;
          margin-left: 6px;
        }
      }
      &:before {
        position: absolute;
        content: " ";
        border-bottom: 2px solid #fff;
        bottom: 15px;
        left: 0;
        width: 100%;
      }
    }
  }
  &.white {
    .pop-title {
      color: #666;
      .pop-title-icon {
        vertical-align: bottom;
        margin-left: 6px;
      }
    }
    &:hover {
      .pop-title {
        font-weight: bold;
        color: #227efa;
        .pop-title-icon {
          vertical-align: bottom;
          margin-left: 6px;
        }
      }
      &:before {
        position: absolute;
        content: " ";
        border-bottom: 2px solid #227efa;
        bottom: 15px;
        left: 0;
        width: 100%;
      }
    }
    &.selected {
      .pop-title {
        font-weight: bold;
        color: #333;
        .pop-title-icon {
          vertical-align: bottom;
          margin-left: 6px;
        }
      }
      &:before {
        position: absolute;
        content: " ";
        border-bottom: 2px solid #333;
        bottom: 15px;
        left: 0;
        width: 100%;
      }
    }
  }
  &:hover {
    .pop-drop {
      visibility: visible;
      .drop-wrapper {
        visibility: visible;
        transform: translateY(0);
        // sultan
        // overflow: hidden;
        // text-align: justify;
        // overflow-y: scroll;
      }
      .drop-wrapper::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .pop-drop {
    position: absolute;
    left: -315px;
    margin: 0 auto;
    visibility: hidden;
    width: 1200px;
    overflow: hidden;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
    .drop-wrapper {
      // height: 600px;
      width: 280px;
      transition: transform 0.2s linear;
      transform: translateY(-100%);
      background-color: rgba(255, 255, 255, 0.9);
      border-right: 1px solid rgba(0, 0, 0, 0.15);
    }
  }

  .drop-item {
    
    padding: 16px;
    &:hover,
    &.selected {
      background: #fff;
      .drop-item-header {

        .header-name {
          .name-text {
            color: #2696fe;
          }
        }
      }
    }
    .drop-item-header {
  
      text-align: left;
      .header-name {
        display: flex;
        .name-text {
          flex: 1;
          font-size: 16px;
        }
        .name-icon {
          transform: rotate(-90deg);
        }
      }
      .header-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: 5px;
        span {
          width: 60px;
          color: #999;
          font-size: 12px;
          text-align: left;
          padding: 5px 0;
          .ellipsis();
        }
      }
    }
    .drop-item-body::-webkit-scrollbar {
      // Chrome Safari
      display: none; 
    }
    .drop-item-body {
      position: absolute;
      left: 280px;
      top: 0;
      width: 920px;
      // height: 600px;
      height: 100%;
      padding: 30px 0;
      overflow-y: scroll;
      //sultan
      background: rgba(255, 255, 255, 1);
      .body-list {
        display: flex;
        padding-bottom: 30px;
        .body-list-name {
          width: 160px;
          line-height: 30px;
          padding-left: 50px;
          text-align: left;
          color: #333;
          font-weight: bold;
          .ellipsis();
        }
        .body-list-item {
          width: 760px;
          text-align: left;
          a {
            display: inline-block;
            min-width: 180px;
            line-height: 30px;
            padding: 0px 20px;
            font-size: 14px;
            color: #999;
            &:hover {
              color: #2696fe;
            }
          }
        }
      }
    }
  }
}
</style>